'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventGroups = function () {
  function EventGroups() {
    var _this = this;

    _classCallCheck(this, EventGroups);

    this.eventGroups = {
      ON_LOAD: 'onLoad',
      ON_RECEIVE_ALARM: 'onReceiveAlarm',
      ON_RENDER_ALARM: 'onRenderAlarm',
      ON_RENDER_ALL: 'onRenderAll',
      ON_DISMISS_ALARM: 'onDismissAlarm',
      CREATE_ALARM: 'createAlarm'
    };

    this.keys().forEach(function (key) {
      var value = _this.eventGroups[key];
      _this[key] = value;
    });
  }

  _createClass(EventGroups, [{
    key: 'keys',
    value: function keys() {
      return Object.keys(this.eventGroups);
    }
  }, {
    key: 'getByKey',
    value: function getByKey(key) {
      return this[key];
    }
  }]);

  return EventGroups;
}();

exports.default = new EventGroups();
module.exports = exports['default'];